import { createPersistedToggle } from "./persisted-toggle";

export const useCableVdropVisibility = createPersistedToggle("twelve-volt:show-cable-vdrop", false);
